import { Modal } from '../../Modal';
import ProjectPositionFormItem from '../ProjectPositionFormItem';
import { useCallback, useContext, useState } from 'react';
import { IPositionsState } from '../../../project-opportunities/create-project-opportunity/CreateProjectOpportunity';
import { initialPosition } from '../../../project-opportunities/create-project-opportunity/CreatePositions';
import { PositionModalContext } from './PositionEntityModal';
import { TEXTS } from '../../../../core/texts';
import { Person } from '@mui/icons-material';
import { ValidationErrorState } from '../../../../types/validationErrorState';
import { FlexBoxFullWidth } from '../../boxes';
import { Button } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { IErrorResponse } from '../../../../interfaces/errorResponse';
import { parseAxiosError } from '../../../../services/axios';
import { Validator } from '../../../../core/Validator';
import NAMES = Validator.NAMES;
import { ButtonWithLoader } from '../../ButtonWithLoader';
import { useNotification } from '../../../../+state/useNotification';

const KEY = 'new';
const CreatePosition = () => {
  const [position, setPosition] = useState<IPositionsState>({ [KEY]: initialPosition });
  const [validationErrors, setValidationErrors] = useState<ValidationErrorState>({});
  const {
    onClose,
    languageCodes,
    positionsWithSkills,
    handleAddNewPosition,
    refreshPositions
  } = useContext(PositionModalContext);
  const { openErrorToast, openSuccessToast } = useNotification();

  const mutation = useMutation({
    mutationFn: () => handleAddNewPosition!(position[KEY]),
    onSuccess: () => {
      openSuccessToast(TEXTS.SUCCESS_SAVED);
      refreshPositions();
      onClose();
    },
    onError: (err: AxiosError<IErrorResponse>) => openErrorToast(parseAxiosError(err))
  });

  const handleSubmit = useCallback(() => {
    const mainErrors = Validator.validate(position[KEY], NAMES.POSITION);
    const rateErrors = Validator.validate(position[KEY].preferredRate, NAMES.RATE);
    const avblErrors = Validator.validate(position[KEY].availability, NAMES.AVAILABILITY);
    const languageErrors = Validator.validate(position[KEY].language, NAMES.LANGUAGE);
    if ([mainErrors, rateErrors, avblErrors, languageErrors].filter(e => !!e).length) {
      return setValidationErrors({ ...mainErrors, ...rateErrors, ...avblErrors, ...languageErrors });
    }
    mutation.mutate();
  }, [position, mutation]);


  return (
    <Modal onClose={onClose} maxWidth={800} title={TEXTS.ADD_POSITION} headerIcon={<Person color={'primary'}/>}
           dialogActions={<FlexBoxFullWidth justifyContent={'space-between'} p={1}>
             <Button variant={'outlined'} onClick={onClose} color={'error'}>{TEXTS.CANCEL}</Button>
             <ButtonWithLoader loading={mutation.isLoading} variant={'outlined'} onClick={handleSubmit}>
               {TEXTS.SAVE}
             </ButtonWithLoader>
           </FlexBoxFullWidth>}
    >
      <ProjectPositionFormItem
        position={position[KEY]}
        positionKey={KEY}
        setPositions={setPosition}
        languageCodes={languageCodes}
        positionsWithSkills={positionsWithSkills}
        withHeader={false}
        validationErrors={validationErrors}
      />
    </Modal>
  );
};

export default CreatePosition;